import {Helper, SelectControl} from '../../../../app/shared/classes';
import {ComponentTypesEnum} from '../../../../app/shared/enums/common';

export const CompanyDocumentTypeSelector = 'companyDocumentType';

export const CompanyDocumentsControl = (): SelectControl => {
    return new SelectControl({
        name: CompanyDocumentTypeSelector,
        value: null,
        placeholder: 'Document type',
        validators: [],
        componentType: ComponentTypesEnum.Select,
        options: Helper.enumsHelper().getCompanyDocumentTypes().getTypeKeys().map((key: string) => {
            return {
                label: Helper.enumsHelper().getCompanyDocumentTypes().getTypeValue(key),
                value: key
            };
        })
    });
};
